import { LocalOfferOutlined } from '@mui/icons-material'
import { Box, Button, Container, Typography } from '@mui/material'
import React from 'react'

export interface ClevertapTextBannerProps {
    title: string
    subTitle: string
    viewDetailsLabel: string
    showViewDetails: boolean
    onViewDetails: () => void
}

/**
 * Presentation for the CleverTap web-native-display (KV) home banner.
 * Styled like SrpTipBanner: offer icon + bold title with subtitle below,
 * and a "View details" action on the right that opens the campaign url.
 */
const ClevertapTextBanner: React.FC<ClevertapTextBannerProps> = ({
    title,
    subTitle,
    viewDetailsLabel,
    showViewDetails,
    onViewDetails
}) => (
    <Container maxWidth="xl">
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 2,
                mb: 2,
                bgcolor: 'common.white',
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1.5,
                width: '100%'
            }}
        >
            <LocalOfferOutlined sx={{ color: 'info.main', fontSize: { xs: 24, md: 28 }, flexShrink: 0 }} />

        <Box sx={{ flex: 1, minWidth: 0 }}>
            {title && (
                <Typography sx={{ fontWeight: 700, fontSize: { xs: 14, md: 16 }, color: 'text.primary', lineHeight: 1.4 }}>
                    {title}
                </Typography>
            )}
            {subTitle && (
                <Typography sx={{ fontSize: { xs: 12, md: 14 }, color: 'text.secondary', lineHeight: 1.5 }}>
                    {subTitle}
                </Typography>
            )}
        </Box>

        {showViewDetails && (
            <Button
                variant="contained"
                onClick={onViewDetails}
                sx={{ flexShrink: 0, borderRadius: 1.5, textTransform: 'none', whiteSpace: 'nowrap' }}
            >
                {viewDetailsLabel}
            </Button>
        )}
        </Box>
    </Container>
)

export { ClevertapTextBanner }
export default ClevertapTextBanner
